import { any } from 'prop-types';
import { useDispatch } from 'react-redux';

import { KovResourcePicker } from '@kathondvla/react-shared-components/src/components';

import type { EditAsideNewsletterSender } from '@nodeTypeConfig/configTypes';
import { patchNodeAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import {
  selectIsNewsletterSenderComponentLoading,
  selectNewsletterSenderOptions,
  selectSelectedNewsletterSender,
} from './asideNewsletterSenderSelectors';

const AsideNewsletterSender: React.FC<{
  config: EditAsideNewsletterSender;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();

  const isLoading = useTypedSelector(selectIsNewsletterSenderComponentLoading);
  const senderOptions = useTypedSelector(selectNewsletterSenderOptions);
  const selectedSender = useTypedSelector((state) => selectSelectedNewsletterSender(state, config));
  const editingHref = useEditHref();

  const onChange = (selection) => {
    dispatch(
      patchNodeAction(getResourceKey(editingHref), {
        newsletterSender: { href: selection.href },
      }),
    );
  };

  const addCursorStyle = (provided) => ({ ...provided, cursor: 'pointer' });

  return (
    <>
      <label className="control-label">{config.label}</label>
      {isLoading ? (
        <div className="form-group shimmer narrowLine" />
      ) : (
        <KovResourcePicker
          value={selectedSender}
          localData={senderOptions}
          display="display"
          clearable={false}
          disabled={readonly}
          disableSearch={true}
          style={{ option: addCursorStyle, valueContainer: addCursorStyle }}
          onChange={onChange}
        />
      )}
    </>
  );
};

AsideNewsletterSender.displayName = 'AsideNewsletterSender';

AsideNewsletterSender.propTypes = { config: any };

export default AsideNewsletterSender;
